<template>
  <v-layout
    mb-8
    wrap
  >
    <v-flex
      mt-2
      mb-2
    >
      <small> {{ $t('whitelabel.tidioHint') }} <a
        href="https://www.tidio.com/en/?ref=awi"
        target="_blank"
      ><b>tidio.com</b></a></small>
    </v-flex>
    <v-flex
      xs12
      md12
    >
      <v-text-field
        v-model.trim="form.tidio_id"
        name="whitelabel-tidio-id"
        maxlength="500"
        :counter="500"
        :error-messages="TidioIdErrors"
        :label="$t('whitelabel.tidioId')"
        @input="$v.form.tidio_id.$touch()"
        @blur="$v.form.tidio_id.$touch()"
      />
    </v-flex>
    <v-flex
      xs12
      md12
    >
      <v-text-field
        v-model.trim="form.telegram_channel_link"
        name="whitelabel-telegram-channel-link"
        maxlength="500"
        :counter="500"
        :error-messages="TelegramChannelLinkErrors"
        :label="$t('whitelabel.telegramChannelLink')"
        @input="$v.form.telegram_channel_link.$touch(); "
        @blur="$v.form.telegram_channel_link.$touch();"
      />
    </v-flex>
    <v-flex
      xs12
      md12
    >
      <v-text-field
        v-model.trim="form.telegram_group_link"
        name="whitelabel-telegram-group-link"
        maxlength="500"
        :counter="500"
        :error-messages="TelegramGroupLinkErrors"
        :label="$t('whitelabel.telegramGroupLink')"
        @input="$v.form.telegram_group_link.$touch()"
        @blur="$v.form.telegram_group_link.$touch();"
      />
    </v-flex>
    <v-flex
      xs12
      md12
    >
      <v-text-field
        v-model.trim="telegram_support_id"
        name="whitelabel-telegram-support-id"
        :prefix="'@'"
        maxlength="500"
        :counter="500"
        :error-messages="TelegramSupportIdErrors"
        :label="$t('whitelabel.telegramSupportId')"
        @input="$v.form.telegram_support_id.$touch()"
        @blur="$v.form.telegram_support_id.$touch()"
      />
    </v-flex>
    <v-flex
      mt-2
      mb-2
    >
      <small> {{ $t('whitelabel.legal') }}</small>
    </v-flex>
    <v-flex
      xs12
      md12
    >
      <v-text-field
        v-model.trim="form.user_agreement_link"
        name="whitelabel-user-agreement-link"
        maxlength="500"
        :counter="500"
        :error-messages="UserAgreementLinkErrors"
        :label="$t('whitelabel.userAgreement')"
        @input="$v.form.user_agreement_link.$touch()"
        @blur="$v.form.user_agreement_link.$touch()"
      />
    </v-flex>
    <v-flex
      xs12
      md12
    >
      <v-text-field
        v-model.trim="form.privacy_policy_link"
        name="whitelabel-privacy-policy-link"
        maxlength="500"
        :counter="500"
        :error-messages="PrivacyPolicyLinkErrors"
        :label="$t('whitelabel.privacyPolicy')"
        @input="$v.form.privacy_policy_link.$touch()"
        @blur="$v.form.privacy_policy_link.$touch()"
      />
    </v-flex>
    <v-flex
      mt-2
      mb-2
    >
      <small> {{ $t('whitelabel.otherLinks') }}</small>
    </v-flex>
    <v-flex
      xs12
      md12
    >
      <v-text-field
        v-model.trim="form.knowledge_base_link"
        name="whitelabel-knowledge-base-link-link"
        maxlength="500"
        :counter="500"
        :error-messages="KnowledgeBaseLinkErrors"
        :label="$t('whitelabel.knowledgeBase')"
        @input="$v.form.knowledge_base_link.$touch()"
        @blur="$v.form.knowledge_base_link.$touch()"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  url,
  maxLength
} from "vuelidate/lib/validators";


import WHITE_LABEL_AFF_PLANS_QUERY from "@/graphql/queries/WhiteLabelAffPlans.gql";


export default {
  name: "WhiteLabelSupport",
  mixins: [validationMixin],
  props: {
    editForm: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      form: {
        tidio_id: null,
        telegram_channel_link: null,
        telegram_group_link: null,
        telegram_support_id: null,
        user_agreement_link: null,
        privacy_policy_link: null,
        knowledge_base_link: null
      }
    };
  },
  validations() {
    return {
      form: this.rules
    };
  },
  computed: {
    telegram_support_id: {
      set(val) {
        this.form.telegram_support_id = val.replace("@", "")
      },
      get() {
        return this.form.telegram_support_id;
      }
    },
    rules() {
      var form = {
        tidio_id: {
          maxLength: maxLength(500),
        },
        telegram_channel_link: {
          url,
          maxLength: maxLength(500),
        },
        telegram_group_link: {
          url,
          maxLength: maxLength(500),
        },
        telegram_support_id: {
          maxLength: maxLength(500),
        },
        user_agreement_link: {
          url,
          maxLength: maxLength(500),
        },
        privacy_policy_link: {
          url,
          maxLength: maxLength(500),
        },
        knowledge_base_link: {
          url,
          maxLength: maxLength(500),
        },
      };
      return form;
    },
    TidioIdErrors() {
      const errors = [];
      if (!this.$v.form.tidio_id.$dirty) return errors;
      !this.$v.form.tidio_id.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.tidio_id.$params.maxLength.max}));
      
      return errors;
    },
    TelegramChannelLinkErrors() {
      const errors = [];
      if (!this.$v.form.telegram_channel_link.$dirty) return errors;
      !this.$v.form.telegram_channel_link.url &&
        errors.push(this.$t("whitelabel.urlError"));
      !this.$v.form.telegram_channel_link.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.telegram_channel_link.$params.maxLength.max}));
      
      return errors;
    },
    TelegramGroupLinkErrors() {
      const errors = [];
      if (!this.$v.form.telegram_group_link.$dirty) return errors;
      !this.$v.form.telegram_group_link.url &&
        errors.push(this.$t("whitelabel.urlError"));
      !this.$v.form.telegram_group_link.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.telegram_group_link.$params.maxLength.max}));
      
      return errors;
    },
    TelegramSupportIdErrors() {
      const errors = [];
      if (!this.$v.form.telegram_support_id.$dirty) return errors;
      !this.$v.form.telegram_support_id.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.telegram_support_id.$params.maxLength.max}));
      
      return errors;
    },
    UserAgreementLinkErrors() {
      const errors = [];
      if (!this.$v.form.user_agreement_link.$dirty) return errors;
      !this.$v.form.user_agreement_link.url &&
        errors.push(this.$t("whitelabel.urlError"));
      !this.$v.form.user_agreement_link.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.user_agreement_link.$params.maxLength.max}));
      
      return errors;
    },
    PrivacyPolicyLinkErrors() {
      const errors = [];
      if (!this.$v.form.privacy_policy_link.$dirty) return errors;
      !this.$v.form.privacy_policy_link.url &&
        errors.push(this.$t("whitelabel.urlError"));
      
      !this.$v.form.privacy_policy_link.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.privacy_policy_link.$params.maxLength.max}));
      
      return errors;
    },
    KnowledgeBaseLinkErrors() {
      const errors = [];
      if (!this.$v.form.knowledge_base_link.$dirty) return errors;
      !this.$v.form.knowledge_base_link.url &&
        errors.push(this.$t("whitelabel.urlError"));
      
      !this.$v.form.knowledge_base_link.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.knowledge_base_link.$params.maxLength.max}));
      
      return errors;
    },
  },
  watch: {
    editForm(value) {
      if (value) {
        this.form = {
          tidio_id: this.editForm.tidio_id,
          telegram_channel_link: this.editForm.telegram_channel_link,
          telegram_group_link: this.editForm.telegram_group_link,
          telegram_support_id: this.editForm.telegram_support_id,
          user_agreement_link: this.editForm.user_agreement_link,
          privacy_policy_link: this.editForm.privacy_policy_link,
          knowledge_base_link: this.editForm.knowledge_base_link
        }
      }
    }
  },
  apollo: {
     whiteLabelAffPlans: {
      query() {
        return WHITE_LABEL_AFF_PLANS_QUERY;
      }
    }
  },
  methods: {
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('saveForm', this.form);
      }
    },
  }
};
</script>

<style lang="scss">

</style>
